import { useState, useEffect, useRef } from "react";

import useFetch from "./useFetch";

import { apiUrl, getBaseUrl, setValToLS, getValFromLS } from "./utils";

import Alert from "./Alert";
import Input from "./Input";
import InputDate from "./InputDate";
import Textarea from "./Textarea";
import Checkbox from "./Checkbox";
import Msg from "./Msg";
import Submit from "./Submit";
import Turnstile from "./Turnstile";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faShoppingBag,
	faChevronCircleRight,
} from "@fortawesome/pro-light-svg-icons";

import S from "./order-styled";
import { Form, FormRow1, FormRow2, FormMsgSubmit } from "./styled";

S.Form = Form;
S.FormRow1 = FormRow1;
S.FormRow2 = FormRow2;
S.FormMsgSubmit = FormMsgSubmit;

const Order = ({ started, brand }) => {
	const [url, setUrl] = useState(null);
	const [details, setDetails] = useState({
		options: [],
	});
	const [selected, setSelected] = useState([]);
	const [names, setNames] = useState({
		delivery: "custom",
	});
	const [errors, setErrors] = useState([]);
	const [msg, setMsg] = useState({});
	const [turnstileToken, setTurnstileToken] = useState(null);

	const formElement = useRef(null);
	const turnstileRef = useRef(null);
	const { loading, data } = useFetch(url);

	const API_URL = apiUrl();

	useEffect(() => {
		//console.log("Order useEffect called for url");

		const newUrl = new URL(`${API_URL}/orderInit`);
		/*
      const params = {
        busId: businessObj.id,
      };
      newUrl.search = new URLSearchParams(params);
    */
		setUrl(newUrl);
	}, []);

	useEffect(() => {
		if (data && data.resp === 1) {
			setDetails({ ...data });
		}
	}, [data]);

	const btns = [
		{
			id: "50",
			name: "$50",
		},
		{
			id: "75",
			name: "$75",
		},
		{
			id: "100",
			name: "$100",
		},
		{
			id: "150",
			name: "$150",
		},
		{
			id: "200",
			name: "$200",
		},
		{
			id: "other",
			name: "Other",
		},
	];

	const handleUpdate = (name, value) => {
		if (name === "same") {
			const fname = formElement.current.fname.value || "";
			const lname = formElement.current.lname.value || "";
			const email = formElement.current.email.value || "";
			formElement.current.contactFname.value = fname;
			formElement.current.contactLname.value = lname;
			formElement.current.contactEmail.value = email;
			setNames((names) => ({
				...names,
				contactFname: fname,
				contactLname: lname,
				contactEmail: email,
				same: !names["same"],
			}));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleClick = (amt) => {
		handleUpdate("amt", amt);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/order`);
		let formData = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			formData.append(key, value);
		});
		formData.append("brand", brand);
		formData.append("giftcards", JSON.stringify(data.giftcards));
		formData.append("href", `${getBaseUrl()}/iframe-communicator.html`);
		formData.append("turnstileToken", turnstileToken);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleAdd(
					json.id,
					json.giftcard,
					json.name,
					json.amt,
					json.delivery,
					json.recipient,
					json.contact,
					json.authnet,
				);
				// json.bpay
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
				turnstileRef.current.reset();
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
			turnstileRef.current.reset();
		}
	};

	const handleAdd = (
		id,
		giftcard,
		name,
		amt,
		delivery,
		recipient,
		contact,
		authnet,
	) => {
		let array = selected;
		array.push({
			id,
			giftcard,
			qty: 1,
			name,
			delivery,
			recipient,
			amt,
		});
		setSelected([...array]);
		setValToLS(
			`${brand}order`,
			JSON.stringify({
				items: array,
				contact,
			}),
			true,
		);
		setValToLS(`${brand}authnet`, JSON.stringify(authnet), true);
		started(1);
	};

	return (
		<div>
			{loading ? (
				<Alert data={{ type: "working", text: "" }} />
			) : data.resp === 0 ? (
				<Alert data={{ type: "error", text: data.text }} />
			) : (
				<>
					<h3 style={{ fontSize: "2rem", marginBottom: "25px" }}>
						Order E-gift cards redeemable across any Maple Hospitality Group
						restaurant: Maple & Ash Chicago, Maple & Ash Scottsdale, Maple & Ash
						Miami, Maple & Ash Boston, Marisella, Monarch & Kessaku.
					</h3>

					{getValFromLS(`${brand}order`, true) &&
						JSON.parse(getValFromLS(`${brand}order`, true)).items.length >
							0 && (
							<S.CartContainer data-brand={brand}>
								<button type="button" onClick={() => started(1)}>
									<div>
										<FontAwesomeIcon icon={faShoppingBag} size="lg" />
										<span>
											{JSON.parse(getValFromLS(`${brand}order`, true)).items
												.length === 1
												? "1 Item"
												: `${
														JSON.parse(getValFromLS(`${brand}order`, true))
															.items.length
												  } Items`}
										</span>
									</div>
								</button>
							</S.CartContainer>
						)}

					<S.Form
						method="post"
						action="/"
						onSubmit={(e) => handleSubmit(e)}
						ref={formElement}
					>
						<S.BtnsGrid data-brand={brand}>
							{btns.map((btn) => {
								return (
									<button
										key={btn.id}
										type="button"
										onClick={() => handleClick(btn.id)}
										className={btn.id === names.amt ? "selected" : ""}
									>
										{btn.name}
									</button>
								);
							})}
						</S.BtnsGrid>

						{names.amt === "other" && (
							<S.FormRow2 style={{ marginBottom: "15px" }}>
								<Input
									name="other"
									label="Other Amount"
									reqd={true}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>

								<div className="empty" />
							</S.FormRow2>
						)}

						<S.FormRow1>
							<h4>Recipient Details</h4>
						</S.FormRow1>

						<S.FormRow2>
							{/*<Select
								name="delivery"
								label="Delivery Date"
								reqd={true}
								autocomplete="off"
								data={[{ value: "", name: "--" }].concat(
									details.options.map((item) => {
										return {
											value: item.value,
											name: item.name,
										};
									})
								)}
								update={handleUpdate}
								errors={errors}
								/>*/}

							{names.delivery === "custom" && (
								<InputDate
									name="custom"
									label="Delivery Date"
									reqd={true}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
									min={details.min}
								/>
							)}

							<div className="empty" />
						</S.FormRow2>

						<p style={{ marginBottom: "25px" }}>
							For security purposes, there is a 7 day delivery delay for e-gift
							cards. For immediate needs, please visit our restaurant during
							opening hours to purchase a physical card in person.
						</p>

						<S.FormRow2>
							<Input
								name="fname"
								label="First Name"
								reqd={true}
								autocomplete="given-name"
								update={handleUpdate}
								errors={errors}
							/>

							<Input
								name="lname"
								label="Last Name"
								reqd={true}
								autocomplete="family-name"
								update={handleUpdate}
								errors={errors}
							/>
						</S.FormRow2>

						<S.FormRow2>
							<Input
								name="email"
								label="Email Address"
								reqd={true}
								autocomplete="email"
								update={handleUpdate}
								errors={errors}
							/>

							<Input
								name="confirm"
								label="Confirm Email"
								reqd={true}
								autocomplete="off"
								update={handleUpdate}
								errors={errors}
							/>
						</S.FormRow2>

						<S.FormRow1>
							<Textarea
								name="comments"
								label="Optional Gift Message"
								reqd={false}
								autocomplete="off"
								update={handleUpdate}
								errors={errors}
								brand={brand}
							/>
						</S.FormRow1>

						<S.FormRow1>
							<h4>Contact Information</h4>
						</S.FormRow1>

						{!names.same && (
							<S.FormRow1>
								<Checkbox
									name="same"
									label="Check to use card recipient as contact information"
									reqd={false}
									autocomplete="off"
									update={handleUpdate}
									note=""
									errors={errors}
								/>
							</S.FormRow1>
						)}

						<S.FormRow2>
							<Input
								name="contactFname"
								label="First Name"
								reqd={true}
								autocomplete="given-name"
								update={handleUpdate}
								errors={errors}
							/>

							<Input
								name="contactLname"
								label="Last Name"
								reqd={true}
								autocomplete="family-name"
								update={handleUpdate}
								errors={errors}
							/>
						</S.FormRow2>

						<S.FormRow2>
							<Input
								name="contactEmail"
								label="Email Address"
								reqd={true}
								autocomplete="email"
								update={handleUpdate}
								errors={errors}
							/>

							<Input
								name="contactPhone"
								label="Phone"
								reqd={true}
								autocomplete="tel"
								update={handleUpdate}
								errors={errors}
							/>
						</S.FormRow2>

						<S.FormRow1 style={{ marginTop: "20px" }}>
							{/* kylan - 0x4AAAAAAFXnfyU3NFpo6-U8 AS - 0x4AAAAAAAf5FcdJg6nTuIJL */}
							<Turnstile
								ref={turnstileRef}
								siteKey="0x4AAAAAAAf5FcdJg6nTuIJL"
								onVerify={function (value) {
									setTurnstileToken(value);
								}}
								onExpire={function () {
									setTurnstileToken("");
								}}
								onError={function () {
									setTurnstileToken("");
									console.error("Turnstile error");
								}}
							/>
						</S.FormRow1>

						<S.FormMsgSubmit>
							{msg.type && <Msg data={msg} />}
							{msg.type !== "working" && (
								<Submit
									name="Continue to Payment"
									icon={faChevronCircleRight}
								/>
							)}
						</S.FormMsgSubmit>
					</S.Form>
				</>
			)}
		</div>
	);
};

export default Order;
